




























































































import {
  SfButton, SfLoader, SfProductCard, SfSection, SfPrice
} from '@storefront-ui/vue';

import {
  computed, defineComponent, onMounted, ref,
} from '@nuxtjs/composition-api';
import {
  useImage, useProduct,
} from '~/composables';
import useWishlist from '~/modules/wishlist/composables/useWishlist';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import { useUser } from '~/modules/customer/composables/useUser';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { SortEnum } from '~/modules/GraphQL/types';
import SvgImage from '~/components/General/SvgImage.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import CursorMagnet from '~/components/Headless/CursorMagnet.vue';
import CircleGradient from '~/components/Headless/Watermarks/CircleGradient.vue';
import { animateOnScroll } from '~/helpers/headless/helpers';

export default defineComponent({
  name: 'NewProducts',
  components: {
    SfProductCard,
    SfSection,
    SfLoader,
    SfButton,
    SfPrice,
    SvgImage,
    Swiper,
    SwiperSlide,
    CursorMagnet,
    CircleGradient
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    categoryId: {
      type: String,
      default: '4'
    },
    swiperOption: {
      type: Object,
      default() {
        return {
          slidesPerView: 'auto',
          grabCursor: true,
          scrollbar: {
            el: '.newproducts-swiper-scrollbar',
            hide: false
          }
        };
      },
    },
    animateProp: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { isAuthenticated } = useUser();
    const { getProductList, loading, getProductPath, } = useProduct();
    const { isInWishlist, addOrRemoveItem } = useWishlist();
    const { addItemToCart, isInCart } = useAddToCart();
    const products = ref([]);

    const mappedProducts = computed(() => products.value.map((product) => ({
      ...product
    })));

    const addItemToWishlist = async (product) => {
      await addOrRemoveItem({ product });
    };

    const { getMagentoImage, imageSizes } = useImage();

    onMounted(async () => {
      const newestProducts = await getProductList({
        filter: {
          category_id: {
            eq: props.categoryId
          }
        },
        pageSize: 4,
        currentPage: 1,
        sort: {
          position: SortEnum.Asc,
        },
      });

      if (newestProducts?.items?.length) {
        products.value = newestProducts.items;
      }
      animateOnScroll();
    });

    return {
      addItemToCart,
      addItemToWishlist,
      isAuthenticated,
      isInCart,
      isInWishlist,
      loading,
      mappedProducts,
      productGetters,
      getMagentoImage,
      imageSizes,
      getProductPath
    };
  },
});
